var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.gameLaunching || _vm.favListAction)?_c('div',{attrs:{"id":"preloader"}},[_c('div',{attrs:{"id":"loader"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }